"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TournamentScheduleActions;
(function (TournamentScheduleActions) {
    TournamentScheduleActions["Loading"] = "Loading";
    TournamentScheduleActions["Loaded"] = "Loaded";
})(TournamentScheduleActions || (TournamentScheduleActions = {}));
exports.default = TournamentScheduleActions;
